import { useState } from 'react';
import { trackEvent } from '~/helpers/tracking';
import { AngleDown } from '../Icons/fill';

interface Props {
  id: string | number;
  title: string;
  children: JSX.Element[] | JSX.Element | string;
}

export function AccordionItem({ id, title, children }: Props): JSX.Element {
  const [expandedState, setExpandedState] = useState(false);

  const handleFAQClick = (event) => {
    trackEvent({
      action: 'elementClicked',
      data: {
        actionOutcome: !expandedState ? 'Item Opened' : 'Item Closed',
        position: !expandedState ? 'Item Opened' : 'Item Closed',
        elementType: 'FAQs',
        location: 'product_selection_page',
        text: title,
      },
      event,
    });
  };

  return (
    <div className="question-wrapper">
      <button
        id={`${id}-header`}
        className={expandedState ? 'faq__title__expanded' : 'faq__title'}
        onClick={(event) => {
          handleFAQClick(event);
          setExpandedState(!expandedState);
        }}
      >
        {title}
        <AngleDown className={expandedState ? 'angleDown__expanded' : 'angleDown'} />
      </button>

      <section id={`${id}-panel`} className={expandedState ? 'faq__content__expanded' : 'faq__content'}>
        {children}
      </section>
    </div>
  );
}

AccordionItem.displayName = 'AccordionItem';
